import { Component } from '@angular/core';

@Component({
    selector: 'app-custom-404',
    templateUrl: './custom-404.template.html',
    styleUrls: [ './custom-404.style.css' ]
})

export class Custom404Component {}
